import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IRecomendationItem} from './recommendations-item/recommendations-item.component';
import {Results} from '../../../routes/results/results.interface';
import {AiAssistantService} from '../../../../../../shared/src/lib/components/ai-assistant/ai-assistant.service';

@Component({
    selector: 'app-recommendations',
    templateUrl: './recommendations.component.html',
    styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit, OnChanges {

    @Input() results: Results;
    @Input() session: any;

    items: IRecomendationItem[] = [];
    isAiSubscription = false;
    activeIds = '';

    constructor(
        private service: AiAssistantService
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.results && !changes.results.firstChange && changes.results.currentValue) {
            this.items = this.results.recommendations;
        }
    }

    ngOnInit(): void {
        this.items = this.results.recommendations;
        this.isAiSubscription = this.service.isAiSubscription;
        if (!this.isAiSubscription) {
            this.activeIds = 'ngb-panel-r';
        }
    }

}
